/**
 * Aggressive scroll function that prevents jumping back
 */
export function scrollToElementWithOffset(elementId: string, offset: number = 120): void {
  const element = document.getElementById(elementId);
  if (!element) return;

  const targetY = Math.max(0, element.offsetTop - offset);

  // Stop any existing smooth scrolling
  document.documentElement.style.scrollBehavior = 'auto';
  document.body.style.scrollBehavior = 'auto';

  // Force immediate scroll multiple ways
  window.scrollTo(0, targetY);
  document.documentElement.scrollTop = targetY;
  document.body.scrollTop = targetY;

  // Keep forcing the position for a bit to prevent interference
  let attempts = 0;
  const forceScroll = () => {
    if (attempts < 10 && Math.abs(window.scrollY - targetY) > 5) {
      window.scrollTo(0, targetY);
      document.documentElement.scrollTop = targetY;
      document.body.scrollTop = targetY;
      attempts++;
      requestAnimationFrame(forceScroll);
    }
  };
  requestAnimationFrame(forceScroll);

  // Add highlight
  element.classList.add('toc-highlight');
  setTimeout(() => element.classList.remove('toc-highlight'), 1500);
}